"use client";

import { BlogLink, Content, Header } from "@/components/shared/public/blogs";
import { useTranslations } from "next-intl";
import {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
  section9,
  section10,
} from "../../../../../../public/images/blogs/officeFloorPlan";

export default function BlogContent() {
  const t = useTranslations("blogs.officeFloorPlan");

  return (
    <>
      <Header
        title={t("header.title")}
        text={t("header.text")}
        src={header}
        alt={t("header.imageAlt")}
      />
      <div className="gs--blog-body flex flex-col gap-10 py-16">
        <Content
          imageFit="cover"
          title={t("sections.section1.title")}
          text={t.rich("sections.section1.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/lageplan">{chunks}</BlogLink>
            ),
          })}
          src={section1}
          alt={t("sections.section1.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section2.title")}
          text={t.rich("sections.section2.text", {
            br: () => <br></br>,
          })}
          src={section2}
          alt={t("sections.section2.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section3.title")}
          text={t.rich("sections.section3.text", {
            br: () => <br></br>,
          })}
          src={section3}
          alt={t("sections.section3.imageAlt")}
          imageLeft={true}
          //imageTop
        />
        <Content
          imageFit="cover"
          title={t("sections.section4.title")}
          text={t.rich("sections.section4.text", {
            br: () => <br></br>,
          })}
          src={section4}
          alt={t("sections.section4.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section5.title")}
          text={t.rich("sections.section5.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/grundriss-kueche">{chunks}</BlogLink>
            ),
          })}
          src={section5}
          alt={t("sections.section5.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section6.title")}
          text={t.rich("sections.section6.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/wohnflaeche">{chunks}</BlogLink>
            ),
          })}
          src={section6}
          alt={t("sections.section6.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section7.title")}
          text={t.rich("sections.section7.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/wohnflaeche">{chunks}</BlogLink>
            ),
            bold: (chunks) => <strong>{chunks}</strong>,
          })}
          src={section7}
          alt={t("sections.section7.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section8.title")}
          text={t.rich("sections.section8.text", {
            br: () => <br></br>,
            bold: (chunks) => <strong>{chunks}</strong>,
          })}
          src={section8}
          alt={t("sections.section8.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section9.title")}
          text={t.rich("sections.section9.text", {
            br: () => <br></br>,
            bold: (chunks) => <strong>{chunks}</strong>,
          })}
          src={section9}
          alt={t("sections.section9.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section10.title")}
          text={t.rich("sections.section10.text", {
            br: () => <br></br>,
            bold: (chunks) => <strong>{chunks}</strong>,
          })}
          src={section10}
          alt={t("sections.section10.imageAlt")}
          imageLeft={true}
          disclaimer="default"
        />
      </div>
    </>
  );
}
